import Extracted from "../public/data/Extracted.json";
import Supplemental from "../public/data/Supplemental.json";
import { AppModule_ensureEntries, VersionModule_tryParse, Util_console, AppModule_version, App, UIState, OpenDetails, SettingsTab, OptimizationObjective, AppMode, CropTabState, CropFiltersModule_empty, Ranker, TimeNormalization, RankMetric, RankItem, Settings, Selections, Selection$2, ProfitSettings, SeedStrategy, SelectionsModule_createAllSelected, Preset, UIState_$reflection, Settings_$reflection, CropFilters, Result_get } from "./Types.js";
import { list, fromString, int64 as int64_1, map, nil as nil_1, oneOf, option as option_3, tuple2 as tuple2_1, bool, string, object as object_1, fromValue } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { GameVariables, GameVariablesModule_common, GameDataModule_fromExtractedAndSupplementalData } from "./Model/Game.js";
import { stringHash, numberHash, equals, compare, comparePrimitives, defaultOf, uncurry2 } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { Encode_mapSeq, Decode_seedId, Encode_seedId, Decode_seasons, Encode_seasons, Decode_date, Encode_date, Decode_supplementalData, Decode_extractedData } from "./Model/Data.js";
import { newGuid } from "./fable_modules/fable-library-js.4.29.0/Guid.js";
import { map as map_1, ofArray as ofArray_1, add } from "./fable_modules/fable-library-js.4.29.0/Map.js";
import { empty } from "./fable_modules/Thoth.Json.10.4.1/Extra.fs.js";
import { ExtraCoders } from "./fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { toString as toString_1, int64, nil, tuple2, option as option_2, object } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { iterate, empty as empty_1, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { toArray, bind, map as map_2, defaultArg, some, value as value_6 } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { Auto_generateBoxedEncoder_437914C6 } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { empty as empty_2, ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { remove, ofArray as ofArray_2, FSharpSet_op_Subtraction } from "./fable_modules/fable-library-js.4.29.0/Set.js";
import { SkillModule_zero, Skills as Skills_1, Profession, Skill } from "./Model/Skills.js";
import { MultipliersModule_common, Multipliers as Multipliers_1 } from "./Model/Items.js";
import { Date$, CropAmountSettingsModule_common, CropAmountSettings } from "./Model/Crops.js";
import { FSharpRef, toString } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { tryParse } from "./fable_modules/fable-library-js.4.29.0/Int32.js";
import { tryParse as tryParse_1 } from "./fable_modules/fable-library-js.4.29.0/Long.js";
import { max, min, tryParse as tryParse_2 } from "./fable_modules/fable-library-js.4.29.0/Double.js";
import { tryParse as tryParse_3 } from "./fable_modules/fable-library-js.4.29.0/Boolean.js";
import { contains, choose } from "./fable_modules/fable-library-js.4.29.0/Array.js";

export const extractedData = Extracted;

export const supplementalData = Supplemental;

function load(json, decoder) {
    return Result_get(fromValue("$", decoder, json));
}

const gameData = GameDataModule_fromExtractedAndSupplementalData(load(extractedData, uncurry2(Decode_extractedData)), load(supplementalData, uncurry2(Decode_supplementalData)));











const settingsCoders = new ExtraCoders((() => {
    let copyOfStruct = newGuid();
    return copyOfStruct;
})(), add("StardewValleyStonks.Date", [Encode_date, Decode_date], empty.Coders));

function encodeCropFilters(filters) {
    return object(toList(delay(() => append(singleton(["ItemNameSearch", filters.ItemNameSearch]), delay(() => append(singleton(["Seasons", Encode_seasons(filters.Seasons)]), delay(() => append(singleton(["InSeason", filters.InSeason]), delay(() => append((filters.Giant != null) ? singleton(["Giant", value_6(filters.Giant)]) : empty_1(), delay(() => append((filters.Regrows != null) ? singleton(["Giant", value_6(filters.Regrows)]) : empty_1(), delay(() => ((filters.Forage != null) ? singleton(["Giant", value_6(filters.Forage)]) : empty_1()))))))))))))));
}

const decodeCropFilters = (() => {
    const u = defaultOf();
    return (path_5) => ((v) => object_1((get$) => {
        let objectArg_2, objectArg_3, objectArg_4, objectArg_5;
        let ItemNameSearch;
        const objectArg = get$.Required;
        ItemNameSearch = objectArg.Field("ItemNameSearch", string);
        let Seasons;
        const objectArg_1 = get$.Required;
        Seasons = objectArg_1.Field("Seasons", uncurry2(Decode_seasons));
        return new CropFilters(ItemNameSearch, (objectArg_2 = get$.Required, objectArg_2.Field("InSeason", bool)), Seasons, (objectArg_3 = get$.Optional, objectArg_3.Field("Regrows", bool)), (objectArg_4 = get$.Optional, objectArg_4.Field("Giant", bool)), (objectArg_5 = get$.Optional, objectArg_5.Field("Forage", bool)));
    }, path_5, v));
})();

const encodeSettings = Auto_generateBoxedEncoder_437914C6(Settings_$reflection(), undefined, settingsCoders, undefined);

const decodeSettings = Auto_generateBoxedDecoder_Z6670B51(Settings_$reflection(), undefined, settingsCoders);

const encodeNestedOption = option_2((() => {
    const enc = option_2(Encode_seedId);
    return (tupledArg) => tuple2(enc, (_arg) => {
        if (_arg != null) {
            if (value_6(_arg) != null) {
                const fert = value_6(_arg);
                return fert;
            }
            else {
                return "";
            }
        }
        else {
            return nil;
        }
    }, tupledArg[0], tupledArg[1]);
})());

const decodeNestedOption = (() => {
    const decoder_1 = tuple2_1((path, value) => option_3(uncurry2(Decode_seedId), path, value), (path_4, value_4) => oneOf(ofArray([(path_1) => ((value_1) => nil_1(undefined, path_1, value_1)), (path_3) => ((value_3) => map((_arg) => {
        if (_arg === "") {
            return some(undefined);
        }
        else {
            return some(_arg);
        }
    }, string, path_3, value_3))]), path_4, value_4));
    return (path_5) => ((value_5) => option_3(uncurry2(decoder_1), path_5, value_5));
})();

const uiCoders = (() => {
    let copyOfStruct, copyOfStruct_1, key_1;
    const extra_3 = new ExtraCoders((copyOfStruct = newGuid(), copyOfStruct), add("StardewValleyStonks.WebApp.CropFilters", [encodeCropFilters, decodeCropFilters], empty.Coders));
    return new ExtraCoders((copyOfStruct_1 = newGuid(), copyOfStruct_1), (key_1 = "Microsoft.FSharp.Core.FSharpOption`1[System.Tuple`2[Microsoft.FSharp.Core.FSharpOption`1[System.UInt32[StardewValleyStonks.SeedNum]],Microsoft.FSharp.Core.FSharpOption`1[Microsoft.FSharp.Core.FSharpOption`1[System.String]]]]", add(key_1, [encodeNestedOption, decodeNestedOption], extra_3.Coders)));
})();

const encodeUI = Auto_generateBoxedEncoder_437914C6(UIState_$reflection(), undefined, uiCoders, undefined);

const decodeUI = Auto_generateBoxedDecoder_Z6670B51(UIState_$reflection(), undefined, uiCoders);

export const Encode_settings = encodeSettings;

export const Encode_cropFilters = encodeCropFilters;

export const Encode_ui = encodeUI;

export const Encode_state = (tupledArg) => tuple2(Encode_settings, Encode_ui, tupledArg[0], tupledArg[1]);

export function Encode_preset(preset) {
    return object(toList(delay(() => append(singleton(["Name", preset.Name]), delay(() => append((preset.UniqueId != null) ? singleton(["UniqueId", int64(value_6(preset.UniqueId))]) : empty_1(), delay(() => singleton(["Settings", encodeSettings(preset.Settings)]))))))));
}

export function Decode_settings() {
    return (arg) => {
        const clo = decodeSettings(arg);
        return clo;
    };
}

export function Decode_cropFilters() {
    return (arg) => {
        const clo = decodeCropFilters(arg);
        return clo;
    };
}

export function Decode_ui() {
    return (arg) => {
        const clo = decodeUI(arg);
        return clo;
    };
}

export const Decode_state = tuple2_1(uncurry2(Decode_settings()), uncurry2(Decode_ui()));

export const Decode_preset = (() => {
    const u = defaultOf();
    return (path_1) => ((v) => object_1((get$) => {
        let objectArg, objectArg_1, objectArg_2;
        return new Preset((objectArg = get$.Required, objectArg.Field("Name", string)), (objectArg_1 = get$.Optional, objectArg_1.Field("UniqueId", uncurry2(int64_1))), (objectArg_2 = get$.Required, objectArg_2.Field("Settings", uncurry2(decodeSettings))));
    }, path_1, v));
})();

export const defaultSettings = (() => {
    let CustomFertilizerPrices;
    const selections = SelectionsModule_createAllSelected(gameData);
    return new Settings(GameVariablesModule_common, new ProfitSettings(new SeedStrategy(0, []), true, true), (CustomFertilizerPrices = (new Selection$2(ofArray_1([["Basic Fertilizer", 4], ["Quality Fertilizer", 19], ["Deluxe Fertilizer", 216], ["Speed-Gro", 25], ["Deluxe Speed-Gro", 42], ["Hyper Speed-Gro", 376]], {
        Compare: comparePrimitives,
    }), selections.CustomFertilizerPrices.Selected)), new Selections(selections.Crops, selections.SeedPrices, selections.NoFertilizer, selections.Fertilizers, selections.FertilizerPrices, selections.SellRaw, selections.Products, selections.UseHarvestedSeeds, selections.UseSeedMaker, selections.UseForageSeeds, new Selection$2(ofArray_1([[831, 24], [833, 400], [885, 8]], {
        Compare: comparePrimitives,
    }), selections.CustomSeedPrices.Selected), CustomFertilizerPrices, new Selection$2(ofArray_1([[495, [294, false]], [496, [294, false]], [497, [294, false]], [498, [294, false]]], {
        Compare: comparePrimitives,
    }), selections.CustomSellPrices.Selected))));
})();

export const defaultPresets = ofArray([new Preset("Year 1", undefined, new Settings(defaultSettings.Game, defaultSettings.Profit, (() => {
    const bind$0040 = defaultSettings.Selected;
    return new Selections(FSharpSet_op_Subtraction(defaultSettings.Selected.Crops, ofArray_2(new Uint32Array([347, 476, 478, 485, 486, 489, 494, 499, 802, 831, 833, 885]), {
        Compare: comparePrimitives,
    })), bind$0040.SeedPrices, bind$0040.NoFertilizer, ofArray_2(["Basic Fertilizer", "Speed-Gro"], {
        Compare: comparePrimitives,
    }), bind$0040.FertilizerPrices, bind$0040.SellRaw, map_1((_arg, products) => remove("Mill", products), defaultSettings.Selected.Products), bind$0040.UseHarvestedSeeds, bind$0040.UseSeedMaker, bind$0040.UseForageSeeds, bind$0040.CustomSeedPrices, bind$0040.CustomFertilizerPrices, bind$0040.CustomSellPrices);
})())), new Preset("End Game", undefined, new Settings((() => {
    let bind$0040_2, bind$0040_5, bind$0040_6;
    const bind$0040_1 = defaultSettings.Game;
    return new GameVariables(bind$0040_1.StartDate, bind$0040_1.EndDate, bind$0040_1.Location, (bind$0040_2 = defaultSettings.Game.Skills, new Skills_1(new Skill(10, defaultSettings.Game.Skills.Farming.Buff), new Skill(10, defaultSettings.Game.Skills.Foraging.Buff), ofArray_2([new Profession(0, []), new Profession(1, []), new Profession(3, []), new Profession(4, [])], {
        Compare: compare,
    }), bind$0040_2.IgnoreSkillLevelRequirements, bind$0040_2.IgnoreProfessionConflicts)), (bind$0040_5 = defaultSettings.Game.Multipliers, new Multipliers_1(bind$0040_5.ProfitMargin, true, bind$0040_5.TillerForForagedFruit)), (bind$0040_6 = defaultSettings.Game.CropAmount, new CropAmountSettings(true, bind$0040_6.LuckBuff, bind$0040_6.GiantCropOrientationsPerTile, bind$0040_6.ShavingToolLevel)), bind$0040_1.JojaMembership, bind$0040_1.Irrigated, bind$0040_1.QualityArtisanProducts);
})(), (() => {
    const bind$0040_7 = defaultSettings.Profit;
    return new ProfitSettings(new SeedStrategy(1, []), bind$0040_7.PayForFertilizer, bind$0040_7.PayForDestroyedFertilizer);
})(), defaultSettings.Selected))]);

export const defaultRanker = new Ranker(new RankItem(1, []), new RankMetric(0, []), new TimeNormalization(2, []), false, [0, 20], undefined);

export const defaultCropTabState = new CropTabState(CropFiltersModule_empty, [4, true], [0, true], [0, true], 0, false);

export const defaultUI = new UIState(new AppMode(0, []), defaultRanker, new OptimizationObjective(0, []), new SettingsTab(2, []), ofArray_2([new OpenDetails(0, []), new OpenDetails(1, []), new OpenDetails(4, []), new OpenDetails(6, []), new OpenDetails(11, []), new OpenDetails(10, []), new OpenDetails(13, []), new OpenDetails(12, [])], {
    Compare: compare,
}), defaultCropTabState, [0, true], [0, true]);

export const defaultApp = new App(gameData, defaultPresets, [defaultSettings, defaultUI]);

function LocalStorage_saveVersion() {
    const data = toString(AppModule_version);
    try {
        localStorage.setItem("Version", data);
    }
    catch (e) {
        Util_console.error(some(new Error((`Failed to save ${"Version"}, local storage might be full.`), { cause: e })));
    }
}

function LocalStorage_trySave(key, encoder, value) {
    const data = toString_1(0, encoder(value));
    const key_1 = key;
    try {
        localStorage.setItem(key_1, data);
    }
    catch (e) {
        Util_console.error(some(new Error((`Failed to save ${key_1}, local storage might be full.`), { cause: e })));
    }
}

export function LocalStorage_saveState(state_, state__1) {
    LocalStorage_trySave("State", Encode_state, [state_, state__1]);
}

export function LocalStorage_savePresets(presets) {
    LocalStorage_trySave("Presets", (seq) => Encode_mapSeq(Encode_preset, seq), presets);
}

function LocalStorage_saveAll(app) {
    LocalStorage_saveVersion();
    const tupledArg = app.State;
    LocalStorage_saveState(tupledArg[0], tupledArg[1]);
    LocalStorage_savePresets(app.Presets);
}

function LocalStorage_tryLoad(key, decoder) {
    const matchValue = localStorage.getItem(key);
    if (matchValue != null) {
        const matchValue_1 = fromString(decoder, matchValue);
        if (matchValue_1.tag === 1) {
            Util_console.error(some(`Failed to load ${key} from local storage: ${matchValue_1.fields[0]}`));
            return undefined;
        }
        else {
            return some(matchValue_1.fields[0]);
        }
    }
    else {
        Util_console.error(some(`Failed to load ${key} from local storage: key not found.`));
        return undefined;
    }
}

function LocalStorage_loadState() {
    return defaultArg(LocalStorage_tryLoad("State", uncurry2(Decode_state)), defaultApp.State);
}

function LocalStorage_loadPresets() {
    return defaultArg(LocalStorage_tryLoad("Presets", (path, value) => list(uncurry2(Decode_preset), path, value)), empty_2());
}

export function LocalStorage_loadApp() {
    let ver;
    const matchValue = map_2(VersionModule_tryParse, localStorage.getItem("Version"));
    if (matchValue != null) {
        if (value_6(matchValue) != null) {
            if ((ver = value_6(matchValue), (ver.Major !== AppModule_version.Major) && (ver.Major !== 0))) {
                const ver_1 = value_6(matchValue);
                throw new Error(`Unexpected major version: ${ver_1.Major}`);
            }
            else {
                const ver_2 = value_6(matchValue);
                let app;
                const State = LocalStorage_loadState();
                app = (new App(gameData, LocalStorage_loadPresets(), State));
                if (equals(ver_2, AppModule_version)) {
                    return app;
                }
                else {
                    const app_1 = AppModule_ensureEntries(gameData, app);
                    LocalStorage_saveAll(app_1);
                    return app_1;
                }
            }
        }
        else {
            throw new Error(`Invalid version: ${localStorage.getItem("Version")}`);
        }
    }
    else {
        Util_console.info(some("No version key found in local storage, loading default app..."));
        LocalStorage_saveAll(defaultApp);
        return defaultApp;
    }
}

export function LocalStorage_subscribe(dispatch) {
    window.onstorage = ((e) => {
        const matchValue = e.key;
        if (matchValue === defaultOf()) {
            window.location.reload();
        }
        else {
            switch (matchValue) {
                case "Version": {
                    if (e.newValue == null) {
                        window.location.reload();
                    }
                    else {
                        const matchValue_1 = VersionModule_tryParse(e.newValue);
                        let matchResult, ver_1;
                        if (matchValue_1 != null) {
                            if (equals(matchValue_1, AppModule_version)) {
                                matchResult = 0;
                                ver_1 = matchValue_1;
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                        switch (matchResult) {
                            case 0: {
                                break;
                            }
                            case 1: {
                                window.location.reload();
                                break;
                            }
                        }
                    }
                    break;
                }
                case "Presets": {
                    if (e.newValue == null) {
                        dispatch(empty_2());
                    }
                    else {
                        const matchValue_2 = fromString((path, value) => list(uncurry2(Decode_preset), path, value), e.newValue);
                        if (matchValue_2.tag === 1) {
                            Util_console.error(some(`Failed to load saved settings from local storage: ${matchValue_2.fields[0]}`));
                        }
                        else {
                            dispatch(matchValue_2.fields[0]);
                        }
                    }
                    break;
                }
                case "State": {
                    break;
                }
                default:
                    Util_console.warn(some(`Unknown key from storage event: ${matchValue}`));
            }
        }
    });
}

function XML_getString(doc, node, path) {
    return (doc.evaluate(path, node, defaultOf(), (XPathResult.STRING_TYPE), defaultOf())).stringValue;
}

function XML_stringValue(doc, node, path) {
    const value = XML_getString(doc, node, path);
    if (value === "") {
        return undefined;
    }
    else {
        return value;
    }
}

function XML_parseWith(parser, doc, node, path) {
    const matchValue = parser(XML_getString(doc, node, path));
    if (matchValue[0]) {
        return some(matchValue[1]);
    }
    else {
        return undefined;
    }
}

const XML_natValue = (doc) => ((node) => ((path) => XML_parseWith((arg) => {
    let outArg = 0;
    return [tryParse(arg, 511, true, 32, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
}, doc, node, path)));

const XML_int64Value = (doc) => ((node) => ((path) => XML_parseWith((arg) => {
    let outArg = 0n;
    return [tryParse_1(arg, 511, false, 64, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
}, doc, node, path)));

const XML_floatValue = (doc) => ((node) => ((path) => XML_parseWith((arg) => {
    let outArg = 0;
    return [tryParse_2(arg, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
}, doc, node, path)));

function XML_optionBoolValue(doc, node, path) {
    return bind((node_1) => {
        const matchValue = node_1.attributes["xsi:nil"];
        if (matchValue == null) {
            let matchValue_2;
            let outArg_1 = false;
            matchValue_2 = [tryParse_3(XML_getString(doc, node_1, "."), new FSharpRef(() => outArg_1, (v_1) => {
                outArg_1 = v_1;
            })), outArg_1];
            if (matchValue_2[0]) {
                return some(matchValue_2[1]);
            }
            else {
                return undefined;
            }
        }
        else {
            const attr = value_6(matchValue);
            return bind((str) => {
                let matchValue_1;
                let outArg = false;
                matchValue_1 = [tryParse_3(str, new FSharpRef(() => outArg, (v) => {
                    outArg = v;
                })), outArg];
                let matchResult;
                if (matchValue_1[0]) {
                    if (matchValue_1[1]) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return some(undefined);
                    default:
                        return undefined;
                }
            }, attr.value);
        }
    }, (doc.evaluate(path, node, defaultOf(), (XPathResult.FIRST_ORDERED_NODE_TYPE), defaultOf())).singleNodeValue);
}

function XML_array(typePath, parser, doc, node, path) {
    return map_2((arrNode) => {
        const arr = [];
        const iter = doc.evaluate(typePath, arrNode, defaultOf(), (XPathResult.UNORDERED_NODE_ITERATOR_TYPE), defaultOf());
        let finished = false;
        while (!finished) {
            const matchValue = iter.iterateNext();
            if (matchValue == null) {
                finished = true;
            }
            else {
                const e = matchValue;
                iterate((item) => {
                    void (arr.push(item));
                }, toArray(parser(e.textContent)));
            }
        }
        return arr;
    }, (doc.evaluate(path, node, defaultOf(), (XPathResult.FIRST_ORDERED_NODE_TYPE), defaultOf())).singleNodeValue);
}

const XML_natArray = (doc) => ((node) => ((path) => XML_array("int", (str) => {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(str, 511, true, 32, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return undefined;
    }
}, doc, node, path)));

const XML_stringArray = (doc) => ((node) => ((path) => XML_array("string", (_arg) => {
    if (_arg === "") {
        return undefined;
    }
    else {
        return _arg;
    }
}, doc, node, path)));

const XML_xmlParser = new DOMParser();

function XML_parse(xml) {
    return XML_xmlParser.parseFromString(xml, "text/xml");
}

export function loadSaveGame(xml) {
    const doc = XML_parse(xml);
    return map_2((farmer) => {
        let bind$0040, bind$0040_1, bind$0040_5;
        const missing = [];
        const tryGet = (name, parser, path, defaultValue) => {
            const matchValue = parser(doc)(farmer)(path);
            if (matchValue == null) {
                void (missing.push(name));
                return defaultValue;
            }
            else {
                return value_6(matchValue);
            }
        };
        const professions = tryGet("Professions", XML_natArray, "professions", new Uint32Array([]));
        const eventsSeen = tryGet("Seen Events", XML_natArray, "eventsSeen", new Uint32Array([]));
        const mailReceived = tryGet("Received Mail", XML_stringArray, "mailReceived", []);
        const specialCharm = defaultArg(tryGet("Special Charm", (doc_1) => ((node) => ((path_1) => XML_optionBoolValue(doc_1, node, path_1))), "hasSpecialCharm", CropAmountSettingsModule_common.SpecialCharm), CropAmountSettingsModule_common.SpecialCharm);
        const farmingLevel = min(10, tryGet("Farming Level", XML_natValue, "farmingLevel", SkillModule_zero.Level));
        const foragingLevel = min(10, tryGet("Foraging Level", XML_natValue, "foragingLevel", SkillModule_zero.Level));
        const day = min(28, max(1, tryGet("Day", XML_natValue, "dayOfMonthForSaveGame", 1)));
        const season = ~~tryGet("Season", XML_natValue, "seasonForSaveGame", 0 >>> 0) | 0;
        const profitMargin = tryGet("Difficulty Modifier", XML_floatValue, "difficultyModifier", MultipliersModule_common.ProfitMargin);
        const farmerName = tryGet("Farmer Name", (doc_2) => ((node_1) => ((path_2) => XML_stringValue(doc_2, node_1, path_2))), "name", "Imported Save");
        const uniqueId = XML_int64Value(doc)(farmer)("UniqueMultiplayerID");
        if (uniqueId == null) {
            void (missing.push("Unique Game ID"));
        }
        return [new Preset(farmerName, uniqueId, new Settings((bind$0040 = defaultSettings.Game, new GameVariables(new Date$(season, day), bind$0040.EndDate, bind$0040.Location, (bind$0040_1 = defaultSettings.Game.Skills, new Skills_1(new Skill(farmingLevel, defaultSettings.Game.Skills.Farming.Buff), new Skill(foragingLevel, defaultSettings.Game.Skills.Foraging.Buff), ofArray_2(choose((tupledArg) => {
            if (contains(tupledArg[1], professions, {
                Equals: (x, y) => (x === y),
                GetHashCode: numberHash,
            })) {
                return tupledArg[0];
            }
            else {
                return undefined;
            }
        }, [[new Profession(0, []), 1], [new Profession(1, []), 4], [new Profession(2, []), 5], [new Profession(3, []), 13], [new Profession(4, []), 16]]), {
            Compare: compare,
        }), bind$0040_1.IgnoreSkillLevelRequirements, bind$0040_1.IgnoreProfessionConflicts)), new Multipliers_1(profitMargin, contains(2120303, eventsSeen, {
            Equals: (x_2, y_2) => (x_2 === y_2),
            GetHashCode: numberHash,
        }), defaultSettings.Game.Multipliers.TillerForForagedFruit), (bind$0040_5 = defaultSettings.Game.CropAmount, new CropAmountSettings(specialCharm, bind$0040_5.LuckBuff, bind$0040_5.GiantCropOrientationsPerTile, bind$0040_5.ShavingToolLevel)), contains("JojaMember", mailReceived, {
            Equals: (x_3, y_3) => (x_3 === y_3),
            GetHashCode: stringHash,
        }), bind$0040.Irrigated, bind$0040.QualityArtisanProducts)), defaultSettings.Profit, defaultSettings.Selected)), missing];
    }, (doc.evaluate("Farmer", doc, defaultOf(), (XPathResult.FIRST_ORDERED_NODE_TYPE), defaultOf())).singleNodeValue);
}

//# sourceMappingURL=Data.js.map
